export default "__VITE_ASSET__B5yKbdy4__"